import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import MenuItems from './MenuItems';
import MenuItemsOnePage from './MenuItemsOnePage';
import MiniCart from './MiniCart';

import flagImg from '../../assets/img/hero/flag.png';
import Logo from '../../assets/img/logo/logo-black-2.png';
import LogoWhite from '../../assets/img/logo/logo-white-2.png';

const HeaderSix = (props) => {
  const { headerClass, headerLogo, isOnePage } = props;
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [isCurrencyDropdownOpen, setIsCurrencyDropdownOpen] = useState(false);
  const languageRef = useRef(null);
  const currencyRef = useRef(null);

  // Handler to toggle Language dropdown
  const toggleLanguageDropdown = () => {
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
    setIsCurrencyDropdownOpen(false);
  };

  // Handler to toggle currency dropdown
  const toggleCurrencyDropdown = () => {
    setIsCurrencyDropdownOpen(!isCurrencyDropdownOpen);
    setIsLanguageDropdownOpen(false);
  };

  // Close the dropdown when clicking outside the button
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        languageRef.current &&
        !languageRef.current.contains(event.target) &&
        currencyRef.current &&
        !currencyRef.current.contains(event.target)
      ) {
        setIsLanguageDropdownOpen(false);
        setIsCurrencyDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [languageRef, currencyRef]);

  useEffect(() => {
    // Sticky Header is displayed after scrolling for 400 pixels
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <>
      <header className={headerClass ? headerClass : ''}>
        <div className="it-header-top-area it-header-top-style-3">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-3 col-lg-6 col-md-6">
                <div className="it-header-top__left d-flex align-items-center">
                  <div className="it-header-top__category-wrap d-none d-md-block">
                    <div
                      ref={languageRef}
                      className={
                        isLanguageDropdownOpen
                          ? 'it-header-top__category open'
                          : 'it-header-top__category'
                      }
                      onClick={() => toggleLanguageDropdown()}
                    >
                      <ul>
                        <li>
                          <a href="javascript:void(0)">
                            <img src={flagImg} alt="" />
                            ENGLISH
                            <span className="ps-1">
                              <i className="fa-regular fa-angle-down"></i>
                            </span>
                          </a>
                          <ul className="it-header-top__category-submenu">
                            <li>
                              <a href="#">Arabic</a>
                            </li>
                            <li>
                              <a href="#">Spanish</a>
                            </li>
                            <li>
                              <a href="#">Mandarin</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="it-header-top__area-wrap d-none d-md-block">
                    <div
                      ref={currencyRef}
                      className={
                        isCurrencyDropdownOpen
                          ? 'it-header-top__area open'
                          : 'it-header-top__area'
                      }
                      onClick={() => toggleCurrencyDropdown()}
                    >
                      <ul>
                        <li>
                          <a href="javascript:void(0)">
                            $ USD
                            <span className="ps-1">
                              <i className="fa-regular fa-angle-down"></i>
                            </span>
                          </a>
                          <ul className="it-header-top__area-submenu">
                            <li>
                              <a href="#">Canada</a>
                            </li>
                            <li>
                              <a href="#">Russia</a>
                            </li>
                            <li>
                              <a href="#">Mexico</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 d-none d-xl-block">
                <div className="it-header-top-text">
                  <p className="mb-0">
                    COVID-19 UPDATE:{' '}
                    <i>We are open with limited hours and staff</i>
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="it-header-top-login text-md-end text-center">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa-light fa-user"></i>Login / Register
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-light fa-heart"></i>My Wishlist
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="header-sticky"
          className={
            isVisible
              ? 'it-header-area it-header-ptb it-header-style-2 it-header-style-3 it-header-style-5 white-bg header-sticky'
              : 'it-header-area it-header-ptb it-header-style-2 it-header-style-3 it-header-style-5 white-bg'
          }
        >
          <div className="container">
            <div className="p-relative">
              <div className="row align-items-center">
                <div className="col-xl-2 col-6 col-sm-5">
                  <div className="it-header-logo">
                    <Link to="/">
                      <img src={headerLogo ? headerLogo : Logo} alt="" />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-7 d-none d-xl-block">
                  <div className="it-header-main-menu it-main-menu">
                    <nav className="it-menu-content">
                      {!isOnePage ? (
                        <MenuItems />
                      ) : (
                        <MenuItemsOnePage onePageStyle="onePage6" />
                      )}
                    </nav>
                  </div>
                </div>
                <div className="col-xl-3 col-6 col-sm-7">
                  <div className="it-header-search-wrap d-flex align-items-center justify-content-end">
                    <div className="it-header-search-box d-none d-md-block">
                      <input type="text" placeholder="يبحث......." />
                      <span className="it-header-search-icon">
                        <i className="flaticon-search-interface-symbol"></i>
                      </span>
                    </div>
                    <div className="it-header-shop p-relative cart ml-30 d-none d-xl-block">
                      <button>
                        <span>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 7.67V6.7C7.5 4.45 9.31 2.24 11.56 2.03C14.24 1.77 16.5 3.88 16.5 6.51V7.89"
                              stroke="currentcolor"
                              strokeWidth="1.5"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M9.00007 22H15.0001C19.0201 22 19.7401 20.39 19.9501 18.43L20.7001 12.43C20.9701 9.99 20.2701 8 16.0001 8H8.00007C3.73007 8 3.03007 9.99 3.30007 12.43L4.05007 18.43C4.26007 20.39 4.98007 22 9.00007 22Z"
                              stroke="currentcolor"
                              strokeWidth="1.5"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M15.4955 12H15.5045"
                              stroke="currentcolor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M8.49451 12H8.50349"
                              stroke="currentcolor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                        </span>
                      </button>
                      <MiniCart />
                    </div>
                    <div className="it-header-bar d-xl-none">
                      <button
                        className="it-menu-bar"
                        onClick={() => setIsOffCanvasOpen(true)}
                      >
                        <span>
                          <i className="fa-regular fa-bars-sort"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="it-offcanvas-area">
        <div className={isOffCanvasOpen ? 'itoffcanvas opened' : 'itoffcanvas'}>
          <div className="itoffcanvas__close-btn">
            <button
              className="close-btn"
              onClick={() => setIsOffCanvasOpen(false)}
            >
              <i className="fal fa-times"></i>
            </button>
          </div>
          <div className="itoffcanvas__logo">
            <Link to="/">
              <img src={LogoWhite} alt="" />
            </Link>
          </div>
          <div className="itoffcanvas__text">
            <p>
              Suspendisse interdum consectetur libero id. Fermentum leo vel orci
              porta non. Euismod viverra nibh cras pulvinar suspen.
            </p>
          </div>
          <div className="it-menu-mobile">
            {!isOnePage ? (
              <MenuItems isMobileMenu />
            ) : (
              <MenuItemsOnePage onePageStyle="onePage6" isMobileMenu />
            )}
          </div>
          <div className="itoffcanvas__info">
            <h3 className="offcanva-title">Get In Touch</h3>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-envelope"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Email</span>
                <a href="maito:hello@yourmail.com">hello@yourmail.com</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-phone-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Phone</span>
                <a href="tel:(00)45611227890">(00) 456 1122 7890</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fas fa-map-marker-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Location</span>
                <a
                  href="htits://www.google.com/maps/@37.4801311,22.8928877,3z"
                  target="_blank"
                >
                  Riverside 255, San Francisco, USA
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOffCanvasOpen ? (
        <div
          className="body-overlay apply"
          onClick={() => setIsOffCanvasOpen(false)}
        ></div>
      ) : (
        <div className="body-overlay"></div>
      )}
    </>
  );
};

export default HeaderSix;
